module.exports = __webpack_public_path__ + "static/media/trendingCard.e7ece570.png";